<template>
  <div>
    <v-row class="mb-6" no-gutters align="center">
      <v-btn
        :icon="$store.state.isMobile"
        :text="!$store.state.isMobile"
        color="indigo accent-3"
        v-on:click="goBack"
      >
        <v-icon :left="!$store.state.isMobile" size="20"
          >mdi-keyboard-backspace</v-icon
        >
        <span v-show="!$store.state.isMobile" style="font-size: 18px;"
          >Back</span
        >
      </v-btn>

      <h1 class="color-services page-heading">Resource Edit</h1>
      <v-spacer />
      <!-- <v-btn
        v-if="
          resourceType
            ? resourceType.name == 'Eblity Assessments' && !formSubmitLoading
            : false
        "
        dark
        color="indigo accent-3"
        @click="previewResource"
      >
        <span class="title">Preview</span>
      </v-btn> -->

      <v-btn
        text
        color="indigo accent-3"
        @click="validateAndShowMessage"
        :loading="formSubmitLoading"
      >
        <span class="title">Save Changes</span>
      </v-btn>
    </v-row>

    <v-row
      justify="center"
      align="center"
      v-if="formLoading"
      style="height:50vh"
    >
      <v-progress-circular
        :size="70"
        color="#5c648b"
        indeterminate
      ></v-progress-circular>
    </v-row>

    <v-card v-if="!formLoading">
      <v-card-text>
        <v-form ref="resourceForm" v-model="resourceValid" lazy-validation>
          <v-row>
            <v-col cols="12" md="6">
              <v-row
                cols="12"
                class="pa-4 flex-column ma-0"
                style="min-height:282px;border: 1px dashed #979797; border-radius: 8px;"
              >
                <v-row class="ma-0">
                  <template v-for="element in thumbnailList">
                    <v-img
                      v-if="element.file_type == 'IMAGE'"
                      :key="element.id"
                      :src="element.file_path"
                      lazy-src="/image-placeholder.png"
                      aspect-ratio="1"
                      :class="
                        selectedFile == element ? 'ma-2 selected-file' : 'ma-2'
                      "
                      max-width="121"
                      width="121"
                      max-height="121"
                      height="121"
                      style="border-radius: 6px;"
                      @click="selectedFile = element"
                    ></v-img>

                    <Media
                      v-else
                      :key="element.id"
                      width="121"
                      max-width="121"
                      height="121"
                      max-height="121"
                      :kind="'video'"
                      :isMuted="false"
                      :src="element.file_path"
                      :autoplay="false"
                      :controls="true"
                      style="border-radius: 6px;"
                      :class="
                        selectedFile == element ? 'ma-2 selected-file' : 'ma-2'
                      "
                      @click="selectedFile = element"
                    ></Media>
                  </template>
                  <v-card
                    width="121"
                    height="121"
                    flat
                    class="add-submission ma-2"
                    @click="
                      !thumbnailUploading ? $refs.thumbnailFile.click() : null
                    "
                  >
                    <v-row
                      class="ma-0 pa-2"
                      justify="center"
                      v-if="!thumbnailUploading"
                    >
                      <input
                        type="file"
                        ref="thumbnailFile"
                        style="display: none"
                        accept="image/*, video/*"
                        v-on:change="uploadTempFile()"
                      />
                      <v-icon>mdi-plus</v-icon>
                      <span>Add Resource Image/Video</span>
                    </v-row>
                  </v-card>
                </v-row>

                <!-- <v-col > -->
                <v-row
                  style="background: #F3F0F7; border-radius: 4px; max-height:50px"
                  align="center"
                  class="px-2"
                  no-gutters
                  v-if="selectedFile != null"
                >
                  <span class="lable-text">File Name:</span>
                  <v-text-field
                    v-model="selectedFile.file_name"
                    placeholder="Enter file name"
                    class="ms-3"
                    hide-details
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-btn
                    tile
                    large
                    color="#5C658B"
                    icon
                    @click="
                      () => {
                        thumbnailList = thumbnailList.filter((el) => {
                          return el != selectedFile;
                        });
                        deleteThumbnails.push(selectedFile.id);
                        selectedFile = null;
                      }
                    "
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-row>
                <!-- </v-col> -->
              </v-row>

              <v-col cols="12" class="pa-4 mt-4">
                <v-row no-gutters>
                  <v-col md="4" class="pt-1">
                    <span class="lable-text">Resource Type</span>
                  </v-col>
                  <v-col xs="8">
                    <v-select
                      :items="resource_type_list"
                      v-model="resourceType"
                      item-text="name"
                      return-object
                      single-line
                      placeholder="Select Resource Type"
                      class="custom-bottom-line"
                      :rules="[rules.required]"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
              </v-col>

              <v-col cols="12" class="pa-4">
                <v-row no-gutters>
                  <v-col md="4" class="pt-1">
                    <span class="lable-text">Title</span>
                  </v-col>
                  <v-col xs="8">
                    <v-text-field
                      v-model="resourceTitle"
                      placeholder="Enter Resource Title"
                      :rules="[rules.required]"
                      class="custom-bottom-line"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
              </v-col>

              <v-col cols="12" class="pa-4">
                <v-row no-gutters>
                  <v-col md="4" class="pt-1 pe-2">
                    <span
                      class="lable-text"
                      v-if="
                        resourceType
                          ? resourceType.name == 'Eblity Assessments'
                          : false
                      "
                    >
                      Why should you take this assessment?
                    </span>
                    <span class="lable-text" v-else>Description</span>
                  </v-col>
                  <v-col xs="8">
                    <v-textarea
                      rows="2"
                      class="custom-bottom-line"
                      :auto-grow="true"
                      v-model="resourceDescription"
                      placeholder="Enter Resource Description"
                      :rules="[rules.required, rules.max250]"
                      :counter="1500"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
              </v-col>

              <v-col cols="12" class="pa-4">
                <v-row no-gutters>
                  <v-col md="4" class="pt-1 pe-2">
                    <span
                      class="lable-text"
                      v-if="
                        resourceType
                          ? resourceType.name == 'Eblity Assessments'
                          : false
                      "
                    >
                      How it works?
                    </span>
                    <span class="lable-text" v-else>Instruction</span>
                  </v-col>
                  <v-col xs="8">
                    <v-textarea
                      rows="2"
                      class="custom-bottom-line"
                      :auto-grow="true"
                      v-model="resourceInstruction"
                      placeholder="Enter Resource Instruction"
                      :rules="[rules.required, rules.max250]"
                      :counter="1500"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
              </v-col>

              <v-col cols="12" class="pa-4">
                <v-row no-gutters>
                  <v-col md="4" class="pt-1">
                    <span class="lable-text">Source</span>
                  </v-col>
                  <v-col xs="8">
                    <v-text-field
                      :rules="
                        resourceType
                          ? resourceType.name == 'Eblity Assessments' ||
                            resourceType.name == 'Webinar'
                            ? []
                            : []
                          : []
                      "
                      v-model="resourceSource"
                      placeholder="Enter Source"
                      class="custom-bottom-line"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
              </v-col>

              <v-col cols="12" class="pa-4">
                <v-row no-gutters>
                  <v-col md="4" class="pt-1 pe-2">
                    <span class="lable-text">Resource Language</span>
                  </v-col>
                  <v-col xs="8">
                    <v-select
                      :items="language_list"
                      v-model="resourceLanguage"
                      item-text="name"
                      return-object
                      single-line
                      placeholder="Select Language"
                      class="custom-bottom-line"
                      :rules="[rules.required]"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
              </v-col>
            </v-col>

            <v-col cols="12" md="6">
              <v-col cols="12" class="pa-4">
                <v-row no-gutters>
                  <v-col md="4" class="pt-2">
                    <span class="lable-text">Skills</span>
                  </v-col>
                  <v-col xs="8">
                    <v-autocomplete
                      class="custom-bottom-line"
                      v-model="selectedSkills"
                      :items="resource_skill_list"
                      chips
                      placeholder="Select Skills"
                      item-text="name"
                      item-value="id"
                      multiple
                      :rules="[rules.required]"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          v-bind="data.attrs"
                          :input-value="data.selected"
                          close
                          @click="data.select"
                          @click:close="removeChip(data.item, 'selectedSkills')"
                          >{{ data.item.name }}</v-chip
                        >
                      </template>
                      <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                          <v-list-item-content
                            v-text="data.item"
                          ></v-list-item-content>
                        </template>
                        <template v-else>
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="data.item.name"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
              </v-col>

<!--              <v-col cols="12" class="pa-4">-->
<!--                <v-row no-gutters>-->
<!--                  <v-col md="4" class="pt-1">-->
<!--                    <span class="lable-text">Age Group</span>-->
<!--                  </v-col>-->
<!--                  <v-col xs="8">-->
<!--                    <v-select-->
<!--                      :items="age_group_list"-->
<!--                      v-model="resourceAgeGroup"-->
<!--                      item-text="name"-->
<!--                      return-object-->
<!--                      single-line-->
<!--                      placeholder="Select Age Group"-->
<!--                      class="custom-bottom-line"-->
<!--                      :rules="[rules.required]"-->
<!--                    ></v-select>-->
<!--                  </v-col>-->
<!--                </v-row>-->
<!--                <v-divider></v-divider>-->
<!--              </v-col>-->

              <v-col cols="12" class="pa-4">
                <v-row no-gutters>
                  <v-col md="4" class="pt-2">
                    <span class="lable-text">Age Group</span>
                  </v-col>
                  <v-col xs="8">
                    <v-autocomplete
                      class="custom-bottom-line"
                      v-model="resourceAgeGroup"
                      :items="age_group_list"
                      chips
                      placeholder="Select Age Groups"
                      item-text="name"
                      item-value="id"
                      multiple
                      :rules="[rules.required]"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          v-bind="data.attrs"
                          :input-value="data.selected"
                          close
                          @click="data.select"
                          @click:close="removeChip(data.item, 'selectedAgeGroup')"
                          >{{ data.item.name }}</v-chip
                        >
                      </template>
                      <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                          <v-list-item-content
                            v-text="data.item"
                          ></v-list-item-content>
                        </template>
                        <template v-else>
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="data.item.name"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
              </v-col>

              <v-col cols="12" class="pa-4">
                <v-row no-gutters>
                  <v-col md="4" class="pt-2">
                    <span class="lable-text">Tags</span>
                  </v-col>
                  <v-col xs="8">
                    <v-autocomplete
                      class="custom-bottom-line"
                      v-model="selectedTags"
                      :items="resource_tag_list"
                      chips
                      placeholder="Select Tags"
                      item-text="name"
                      item-value="id"
                      multiple
                      :rules="[rules.required]"
                    >
                      <template v-slot:no-data>
                        <v-list-item @click="addNewTagDialog = true">
                          <v-list-item-icon>
                            <v-icon color="indigo accent-3">mdi-plus</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title style="color:#3d5afe"
                              >Add New Tag</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                      <template v-slot:selection="data">
                        <v-chip
                          v-bind="data.attrs"
                          :input-value="data.selected"
                          close
                          @click="data.select"
                          @click:close="removeChip(data.item, 'selectedTags')"
                          >{{ data.item.name }}</v-chip
                        >
                      </template>
                      <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                          <v-list-item-content
                            v-text="data.item"
                          ></v-list-item-content>
                        </template>
                        <template v-else>
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="data.item.name"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
              </v-col>

              <v-col cols="12" class="pa-4" v-if="authToken.is_eblity_admin()">
                <v-col class="ps-0">
                  <span class="lable-text">Privacy Settings</span>
                </v-col>

                <v-radio-group
                  v-model="resourcePrivacy"
                  v-if="!authToken.is_eblity_admin()"
                >
                  <v-layout row wrap class="ps-3">
                    <v-flex
                      xs12
                      sm6
                      v-for="n in privacy_list_client.length"
                      :key="privacy_list_client[n - 1]"
                    >
                      <v-radio
                        :label="privacy_list_client[n - 1]"
                        :value="privacy_list_client[n - 1]"
                        color="#5C658B"
                        class="mb-2"
                      ></v-radio>
                    </v-flex>
                  </v-layout>
                </v-radio-group>

                <v-radio-group
                  v-model="resourcePrivacy"
                  v-else-if="authToken.is_eblity_admin()"
                >
                  <v-layout row wrap class="ps-3">
                    <v-flex
                      xs12
                      sm6
                      v-for="n in privacy_list_admin.length"
                      :key="privacy_list_admin[n - 1]"
                    >
                      <v-radio
                        :label="privacy_list_admin[n - 1]"
                        :value="privacy_list_admin[n - 1]"
                        color="#5C658B"
                        class="mb-2"
                      ></v-radio>
                    </v-flex>
                  </v-layout>
                </v-radio-group>
                <v-divider></v-divider>
              </v-col>

              <v-col
                cols="12"
                class="pa-4"
                v-if="false"
              >
                <v-row no-gutters>
                  <v-col cols="4" class="pt-2">
                    <span class="lable-text">Countries</span>
                  </v-col>
                  <v-col cols="8">
                    <v-autocomplete
                      class="custom-bottom-line"
                      v-model="selectedCountries"
                      :items="country_list"
                      chips
                      placeholder="Select Countries"
                      item-text="name"
                      item-value="id"
                      multiple
                      :rules="[rules.required]"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          v-bind="data.attrs"
                          :input-value="data.selected"
                          close
                          @click="data.select"
                          @click:close="
                            removeChip(data.item, 'selectedCountries')
                          "
                          >{{ data.item.name }}</v-chip
                        >
                      </template>
                      <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                          <v-list-item-content
                            v-text="data.item"
                          ></v-list-item-content>
                        </template>
                        <template v-else>
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="data.item.name"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
              </v-col>

              <v-card flat color="#F3F0F7" class="pa-4 ma-2">
                <span class="submission-title">Resource Files</span>

                <v-row class="ma-0">
                  <template v-for="element in resourceList">
                    <v-hover v-slot:default="{ hover }" :key="element.id">
                      <v-card width="121" height="121" flat class="me-6 mt-6">
                        <v-img
                          v-if="
                            element.file_type == 'IMAGE' ||
                              element.file_type == 'PDF' ||
                              element.file_type == 'DOC' ||
                              element.file_type == 'DOCX'
                          "
                          @click="
                            element.file_type == 'IMAGE'
                              ? openOverlay(element.file_path)
                              : openUrl(element.file_path)
                          "
                          height="121"
                          width="121"
                          :src="
                            element.file_type == 'IMAGE'
                              ? element.file_path
                              : element.file_type == 'PDF'
                              ? pdfPlaceHolder
                              : element.file_type == 'DOC' ||
                                element.file_type == 'DOCX'
                              ? docPlaceHolder
                              : null
                          "
                          style="cursor: pointer; border-radius: 9px"
                          class="ma-0"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="#5c648b"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                          <v-expand-transition>
                            <div
                              v-if="hover"
                              class="d-flex transition-fast-in-fast-out v-card--reveal white--text"
                              style="height: 100%;"
                            >
                              <span
                                class="subtitle-2"
                                style="width: 112px; text-align: center;"
                                >{{ element.file_name }}</span
                              >
                            </div>
                          </v-expand-transition>
                        </v-img>

                        <Media
                          v-else
                          :key="element.id"
                          width="121"
                          height="121"
                          :kind="'video'"
                          :isMuted="false"
                          :src="element.file_path"
                          :autoplay="false"
                          :controls="true"
                          style="cursor: pointer; border-radius: 9px"
                          @click="selectedFile = element"
                        ></Media>

                        <v-btn
                          color="white"
                          fab
                          x-small
                          light
                          style="position: absolute; top: -15px; right: -15px;"
                          @click="showResourceSubmissionModal(element)"
                        >
                          <v-icon color="indigo accent-3">mdi-close</v-icon>
                        </v-btn>
                      </v-card>
                    </v-hover>
                  </template>

                  <v-card
                    width="121"
                    height="121"
                    flat
                    class="add-submission mt-6"
                    @click="
                      !resourceUploading ? $refs.resourceFile.click() : null
                    "
                  >
                    <v-row
                      class="ma-0 pa-2"
                      justify="center"
                      v-if="!resourceUploading"
                    >
                      <input
                        type="file"
                        ref="resourceFile"
                        style="display: none"
                        accept="application/pdf, image/jpeg, image/png, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, video/*"
                        v-on:change="uploadResourceFile()"
                      />
                      <v-icon>mdi-cloud-upload</v-icon>
                      <span>Click to upload file</span>
                    </v-row>
                  </v-card>
                </v-row>

                <v-dialog v-model="overlay" height="50vh">
                  <v-img :src="overlayImageUrl" contain max-height="100vh">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="white"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-dialog>

                <v-dialog
                  v-model="resourceDeleteModal"
                  persistent
                  max-width="800"
                >
                  <v-card>
                    <v-card-title>
                      <span class="modal-heading">Delete Submission</span>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="indigo accent-3"
                        text
                        @click="resourceDeleteModal = false"
                        class="search-btn"
                      >
                        <v-icon size="16" left>mdi-close</v-icon>
                        <span>Close</span>
                      </v-btn>
                    </v-card-title>
                    <v-card-text>
                      <v-row class="ma-0">
                        <v-hover
                          v-if="resourceToDelete"
                          v-slot:default="{ hover }"
                          :key="resourceToDelete.id"
                        >
                          <v-card width="121" height="121" flat class="me-6">
                            <v-img
                              v-if="
                                resourceToDelete.file_type == 'IMAGE' ||
                                  resourceToDelete.file_type == 'PDF' ||
                                  resourceToDelete.file_type == 'DOC' ||
                                  resourceToDelete.file_type == 'DOCX'
                              "
                              @click="
                                resourceToDelete.file_type == 'IMAGE'
                                  ? openOverlay(resourceToDelete.file_path)
                                  : openUrl(resourceToDelete.file_path)
                              "
                              height="121"
                              width="121"
                              :src="
                                resourceToDelete.file_type == 'IMAGE'
                                  ? resourceToDelete.file_path
                                  : resourceToDelete.file_type == 'PDF'
                                  ? pdfPlaceHolder
                                  : docPlaceHolder
                              "
                              style="cursor: pointer; border-radius: 9px"
                              class="ma-0"
                            >
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height ma-0"
                                  align="center"
                                  justify="center"
                                >
                                  <v-progress-circular
                                    indeterminate
                                    color="#5c648b"
                                  ></v-progress-circular>
                                </v-row>
                              </template>
                              <v-expand-transition>
                                <div
                                  v-if="hover"
                                  class="d-flex transition-fast-in-fast-out v-card--reveal white--text"
                                  style="height: 100%;"
                                >
                                  <span
                                    class="subtitle-2"
                                    style="width: 112px; text-align: center;"
                                  >
                                    {{ resourceToDelete.file_name }}
                                  </span>
                                </div>
                              </v-expand-transition>
                            </v-img>

                            <Media
                              v-else
                              :key="resourceToDelete.id"
                              width="121"
                              height="121"
                              :kind="'video'"
                              :isMuted="false"
                              :src="resourceToDelete.file_path"
                              :autoplay="false"
                              :controls="true"
                              style="cursor: pointer; border-radius: 9px"
                            ></Media>
                          </v-card>
                        </v-hover>

                        <v-col class="custom-lable-field">
                          Are you sure you want to delete this Resource ?
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn
                        color="indigo accent-3"
                        dark
                        style="width:200px"
                        class="mb-4 me-2"
                        @click="deleteResourceFile"
                      >
                        Yes
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <v-dialog v-model="confirmSubmit" max-width="568">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn tile large color="#5C658B" icon @click="confirmSubmit = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="confirmation-text">
          Creators should only upload resources that they have made or that
          they're authorised to use. That means that they should not upload
          resources that they didn't make, or use content in their resources
          that someone else owns the copyright to, without necessary
          authorisations.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="indigo accent-3"
            dark
            style="width:200px"
            class="mb-4 me-2"
            @click="validateAndEdit"
            >Yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addNewTagDialog" max-width="568">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            tile
            large
            color="#5C658B"
            icon
            @click="addNewTagDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="tagForm">
            <v-text-field
              v-model="newTagName"
              :rules="[rules.required]"
              label="Enter New Tag"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="indigo accent-3"
            dark
            style="width:200px"
            class="mb-4 me-2"
            @click="addNewTag"
            :loading="addTagLoading"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <PreviewDialog />
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import Axios from "../../../../api/BaseAxios";
  import { API_CLIENT_URL, ROUTER_URL } from "../../../../constants/urls";
  import Keys from "../../../../constants/keys";

  import store from "../../../../store";
  import RULES from "../../../../common/fieldRules";

  import MasterPermissionKeys from "../../../../constants/PermissionKeys";
  import Helper from "../../../../helper";

  import Media from "@dongido/vue-viaudio";

  import CommonApiHelper from "../../../../api/common/CommonApis";

  import authToken from "../../../../common/authToken";
  import AmplitudeHelper from "../../../../amplitude";

  import PreviewDialog from "../Preview/PreviewDialog";

  export default {
    name: "AddResource",
    components: { Media, PreviewDialog },
    data: (vm) => ({
      pdfPlaceHolder: require("@/assets/pdfPlaceHolder.png"),
      docPlaceHolder: require("@/assets/docPlaceHolder.png"),
      router: ROUTER_URL,
      rules: RULES,
      formLoading: true,
      formSubmitLoading: false,
      id: 0,
      addNewTagDialog: false,
      PermissionKeys: [],
      date: new Date().toISOString().substr(0, 10),
      today: new Date().toISOString().substr(0, 10),
      dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
      confirmSubmit: false,

      language_list: [],
      resource_type_list: [],
      resource_skill_list: [],
      resource_tag_list: [],
      age_group_list: [],
      country_list: [],
      // privacy_list_client: [
      //   "Draft (Only Me)",
      //   "My Organization",
      //   "Everyone",
      //   "Invite only",
      // ],

      privacy_list_client: ["Everyone"],

      // privacy_list_admin: ["Draft (Only Me)", "Everyone", "Invite only"],
      privacy_list_admin: ["Everyone", "My Organization or Invite only"],

      resourcePrivacy: "My Organization or Invite only",
      resourceLanguage: null,
      resourceAgeGroup: null,
      resourceSource: null,
      resourceType: null,
      resourceInstruction: null,
      resourceDescription: null,
      resourceTitle: null,
      selectedSkills: null,
      selectedTags: null,
      selectedCountries: null,

      thumbnailList: [],
      thumbnailUploading: false,
      selectedFile: null,

      resourceList: [],
      resourceUploading: false,

      resourceToDelete: null,
      resourceDeleteModal: false,
      overlay: false,
      overlayImageUrl: null,

      resourceValid: false,

      addTagLoading: false,
      newTagName: null,
      authToken: authToken,

      deleteThumbnails: [],
      newThumbnails: [],

      deleteResourceFileList: [],
      newResourceFileList: [],
    }),
    created() {
      this.id = this.$route.params.id;
      this.PermissionKeys = MasterPermissionKeys;
    },
    computed: {
      ...mapGetters({
        permissions: "mainStore/getPermissions",
      }),
      computedDateFormatted() {
        return this.formatDate(this.date);
      },
    },
    watch: {
      date() {
        this.dateFormatted = this.formatDate(this.date);
      },
      dateFormatted(val) {
        switch (val.length) {
          case 2:
            this.dateFormatted = this.dateFormatted + "/";
            break;
          case 5:
            this.dateFormatted = this.dateFormatted + "/";
            break;
        }
        if (Keys.date_regex.test(val)) {
          let dateParts = val.split("/");
          this.date = new Date(
            +dateParts[2],
            dateParts[1] - 1,
            +dateParts[0] + 1
          )
            .toISOString()
            .substr(0, 10);
        }
      },
    },
    methods: {
      removeChip(item, type) {
        console.log(type);
        switch (type) {
          case "selectedSkills": {
            const index = this.selectedSkills.indexOf(item.id);
            if (index >= 0) this.selectedSkills.splice(index, 1);
            break;
          }

          case "selectedAgeGroup": {
            const index = this.resourceAgeGroup.indexOf(item.id);
            if (index >= 0) this.resourceAgeGroup.splice(index, 1);
            break;
          }

          case "selectedTags": {
            const index = this.selectedTags.indexOf(item.id);
            if (index >= 0) this.selectedTags.splice(index, 1);
            break;
          }
          case "selectedCountries": {
            const index = this.selectedCountries.indexOf(item.id);
            if (index >= 0) this.selectedCountries.splice(index, 1);
            break;
          }
        }
      },

      uploadTempFile() {
        this.fileToUpload = this.$refs.thumbnailFile.files[0];

        var self = this;

        this.thumbnailUploading = true;
        const successHandler = (res) => {
          self.thumbnailUploading = false;
          self.thumbnailList.push(res.data.data);
          self.selectedFile = self.thumbnailList[self.thumbnailList.length - 1];
          self.newThumbnails.push(res.data.data);
        };

        const failureHandler = (res) => {
          console.log(res);
          self.thumbnailUploading = false;
        };

        let formData = new FormData();
        formData.append(Keys.FILE, this.fileToUpload);
        formData.append(
          Keys.FILE_NAME,
          this.$refs.thumbnailFile.files[0].name.split(".")[0]
        );

        CommonApiHelper.uploadTempFile(
          formData,
          successHandler,
          failureHandler
        );
      },
      uploadResourceFile() {
        this.fileToUpload = this.$refs.resourceFile.files[0];

        var self = this;

        this.resourceUploading = true;
        const successHandler = (res) => {
          self.resourceUploading = false;
          self.resourceList.push(res.data.data);
          self.newResourceFileList.push(res.data.data);
        };

        const failureHandler = (res) => {
          console.log(res);
          self.resourceUploading = false;
        };

        let formData = new FormData();
        formData.append(Keys.FILE, this.fileToUpload);
        formData.append(Keys.FILE_NAME, this.$refs.resourceFile.files[0].name);

        CommonApiHelper.uploadTempFile(
          formData,
          successHandler,
          failureHandler
        );
      },
      showResourceSubmissionModal(submission) {
        this.resourceToDelete = submission;
        this.resourceDeleteModal = true;
      },
      deleteResourceFile() {
        this.resourceList = this.resourceList.filter((el) => {
          return el != this.resourceToDelete;
        });
        this.deleteResourceFileList.push(this.resourceToDelete.id);
        this.resourceDeleteModal = false;
      },
      getFormData() {
        var self = this;

        self.formLoading = true;

        const successHandler = (res) => {
          self.formLoading = false;
          self.resource_type_list = res.data.resource_types_list;
          self.language_list = res.data.languages_list;
          self.resource_skill_list = res.data.skills_list;
          self.resource_tag_list = res.data.tags_list;
          self.age_group_list = res.data.age_group_list;
        };

        const failureHandler = (res) => {
          console.log(res);
        };

        Axios.request_GET(
          API_CLIENT_URL.resourceAdd,
          {},
          {},
          successHandler,
          failureHandler,
          false
        );
      },
      getCountries() {
        var self = this;

        const successHandler = (res) => {
          self.country_list = res.data.data;
        };

        const failureHandler = (res) => {
          console.log(res);
        };

        let requestParams = {};
        requestParams[Keys.LENGTH] = -1;
        requestParams[Keys.PAGE] = 1;

        CommonApiHelper.getCountryList(
          requestParams,
          successHandler,
          failureHandler
        );
      },

      validateAndEdit() {
        this.confirmSubmit = false;
        var self = this;

        if (this.validateForm()) {
          let requestParams = {};
          requestParams[Keys.RESOURCE_ID] = this.id;
          requestParams[Keys.TITLE] = this.resourceTitle;
          requestParams[Keys.DESCRIPTION] = this.resourceDescription;
          requestParams[Keys.INSTRUCTION] = this.resourceInstruction;
          requestParams[Keys.RESOURCE_TYPE_ID] = this.resourceType.id;
          requestParams[Keys.RESOURCE_SOURCE] = this.resourceSource;
          requestParams[Keys.LANGUAGE_ID] = this.resourceLanguage.id;

          requestParams[Keys.SKILLS] = this.selectedSkills;
          requestParams[Keys.AGE_GROUPS] = this.resourceAgeGroup;

          requestParams[Keys.TAGS] = this.selectedTags;
          requestParams[Keys.PRIVACY] =
            this.resourcePrivacy == "Draft (Only Me)"
              ? "Only me"
              : this.resourcePrivacy;

          requestParams[Keys.COUNTRIES] = this.selectedCountries;

          for (let i = 0; i < this.thumbnailList.length; i++) {
            if (this.newThumbnails.indexOf(this.thumbnailList[i]) > -1) {
              this.newThumbnails[
                this.newThumbnails.indexOf(this.thumbnailList[i])
              ]["order"] = i + 1;
            }
          }
          requestParams[Keys.NEW_THUMBNAILS] = this.newThumbnails;
          requestParams[Keys.DELETE_THUMBNAILS] = this.deleteThumbnails;

          requestParams[
            Keys.DELETE_RESOURCE_FILES
          ] = this.deleteResourceFileList;
          // requestParams[Keys.DELETE_THUMBNAILS] = this.deleteThumbnails;

          let resourceIdList = [];
          for (let i = 0; i < this.newResourceFileList.length; i++) {
            resourceIdList.push(this.newResourceFileList[i]["id"]);
          }
          requestParams[Keys.NEW_RESOURCE_FILES] = resourceIdList;

          console.log(requestParams);

          self.formSubmitLoading = true;

          const successHandler = (res) => {
            console.log(res);
            AmplitudeHelper.registerEvent(
              "Resource - Edit - Success",
              requestParams
            );
            store.dispatch("snackBar/showToast", {
              message: "Resource Edited successfully",
              color: "S",
            });
            self.goBack();
            //   self.$router.push({
            //     name: this.router.clientPanel.children.resources.children
            //       .resourceDetails.name,
            //     params: { id: res.data.data.id },
            //   });
            self.$refs.resourceForm.reset();
            self.formSubmitLoading = false;
          };

          const failureHandler = (res) => {
            console.log(res);
            self.formSubmitLoading = false;
          };

          Axios.request_PATCH(
            API_CLIENT_URL.resourceEdit,
            requestParams,
            {},
            successHandler,
            failureHandler,
            false
          );
        }
      },
      validateAndShowMessage() {
        if (this.validateForm()) {
          this.confirmSubmit = true;
        }
      },
      validateForm() {
        if (this.$refs.resourceForm.validate()) {
          if (this.thumbnailList.length < 1) {
            store.dispatch("snackBar/showToast", {
              message: "Thumbnails cannot be empty ",
              color: "E",
            });
          }
        } else {
          store.dispatch("snackBar/showToast", {
            message: "Mandatory fields missing",
            color: "E",
          });
        }
        return (
          this.$refs.resourceForm.validate() && this.thumbnailList.length > 0
        );
      },

      addNewTag() {
        if (this.$refs.tagForm.validate()) {
          var self = this;

          this.addTagLoading = true;
          const successHandler = (res) => {
            self.addTagLoading = false;
            self.addNewTagDialog = false;
            self.resource_tag_list.push(res.data.data);
          };

          const failureHandler = (res) => {
            console.log(res);
            self.addTagLoading = false;
            self.addNewTagDialog = false;
          };

          let requestParams = {};
          requestParams[Keys.NAME] = this.newTagName;

          CommonApiHelper.addNewResourceTag(
            requestParams,
            successHandler,
            failureHandler
          );
        }
      },
      previewResource() {
        if (this.validateForm()) {
          let res = {
            id: -1,
            resource_details: {},
          };
          let self = this;

          res.resource_details.title = self.resourceTitle;
          res.resource_details.description = self.resourceDescription;
          res.resource_details.instruction = self.resourceInstruction;
          res.resource_details.resource_type = self.resourceType;
          res.resource_details.source = self.resourceSource;
          res.resource_details.language = self.resourceLanguage;
          res.resource_details.age_group = self.resourceAgeGroup;

          res.resource_details.skills = [];
          self.selectedSkills.forEach((element) => {
            res.resource_details.skills.push(element.id);
          });

          res.resource_details.tags = [];
          self.selectedTags.forEach((element) => {
            res.resource_details.tags.push(element.id);
          });

          res.resource_details.countries = [];
          if (self.selectedCountries)
            self.selectedCountries.forEach((element) => {
              res.resource_details.countries.push(element.id);
            });

          res.resource_details.privacy =
            self.resourcePrivacy == "Only me"
              ? "Draft (Only Me)"
              : self.resourcePrivacy;

          res.resource_details.resource_files = self.resourceList;
          res.resource_details.thumbnails = self.thumbnailList;

          this.$store.state.parentAuth.studentResourceData = res;
          console.log(this.$store.state.parentAuth.studentResourceData);

          this.$store.state.resourcePreviewPopup = true;

          // this.$router.push({
          //   name: this.router.clientPanel.children.resources.children
          //     .resourcePreview.name,
          // });
          // store.dispatch("snackBar/showToast", {
          //   message: "Work in Progress",
          //   color: "S",
          // });
        }
      },

      formatDate(date) {
        if (!date) return null;

        const [year, month, day] = date.split("-");
        return `${day}/${month}/${year}`;
      },
      parseDate(date) {
        if (!date) return null;

        const [month, day, year] = date.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      },
      goBack() {
        Helper.goBack();
      },

      getResourceDetails() {
        var self = this;

        self.loading = true;

        const successHandler = (res) => {
          self.loading = false;
          self.resourceDetails = res.data.data;

          self.resourceTitle = res.data.data.title;
          self.resourceDescription = res.data.data.description;
          self.resourceInstruction = res.data.data.instruction;
          self.resourceType = res.data.data.resource_type;
          self.resourceSource = res.data.data.source;
          self.resourceLanguage = res.data.data.language;
          // self.resourceAgeGroup = res.data.data.age_groups;

          self.resourceAgeGroup = [];
          res.data.data.age_groups.forEach((element) => {
            self.resourceAgeGroup.push(element.id)
          });

          self.selectedSkills = [];
          res.data.data.skills.forEach((element) => {
            self.selectedSkills.push(element.id);
          });

          self.selectedTags = [];
          res.data.data.tags.forEach((element) => {
            self.selectedTags.push(element.id);
          });

          self.selectedCountries = [];
          res.data.data.countries.forEach((element) => {
            self.selectedCountries.push(element.id);
          });

          self.resourcePrivacy =
            res.data.data.privacy == "Only me"
              ? "Draft (Only Me)"
              : res.data.data.privacy;

          self.resourceList = res.data.data.resource_files;
          self.thumbnailList = res.data.data.thumbnails;
        };

        const failureHandler = (res) => {
          console.log(res);
          self.loading = false;
        };

        let requestParams = {};
        requestParams[Keys.ID] = this.id;

        Axios.request_GET(
          API_CLIENT_URL.resourceDetails,
          requestParams,
          {},
          successHandler,
          failureHandler,
          false
        );
      },
      openUrl(url) {
        window.open(url, "_blank");
      },
      openOverlay(url) {
        this.overlay = true;
        this.overlayImageUrl = url;
      },
    },
    mounted() {
      this.getFormData();
      this.getCountries();
      this.getResourceDetails();
    },
  };
</script>

<style scoped>
  .submission-title {
    color: #333333;
    font-size: 1.125rem;
    font-weight: 900;
    letter-spacing: 0;
    line-height: 25px;
  }

  .add-submission {
    border: 1px dashed #979797;
  }
  .add-submission span {
    color: #333333;
    font-size: 1rem;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 19px;
    text-align: center;
  }
  .add-submission > .row {
    height: 121px;
  }

  .v-card--reveal {
    align-items: flex-end;
    bottom: 0;
    justify-content: center;
    position: absolute;
    width: 100%;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      #000000 99.93%
    );
  }

  .selected-file {
    border: 2px solid #4f6cff;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.25));
  }

  .confirmation-text {
    font-weight: 500;
    font-size: 1.125rem;
    line-height: 22px;

    color: #333333;
  }
</style>
